import Content from "uxp-documentation/src/pages/uxp-api/reference-html//Hierarchy/index.md";
import * as React from 'react';
export default {
  Content,
  React
};